import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, mediaUrl } from "../lib/api";
import { Reveal } from "./Reveal";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "./ui/carousel";
import { ArrowUpRight } from "lucide-react";

export function HomeArticleCarousel() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles", { params: { limit: 12 } }).then((r) => setArticles(r.data)).catch(() => setArticles([]));
  }, []);

  if (!articles.length) return null;

  return (
    <section data-testid="home-articles-carousel" className="bg-[#0B1220] py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="text-xs font-semibold uppercase tracking-[0.28em] text-[#5B9DFF]">Dal blog</span>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F4F8FF] mt-3">
              Approfondimenti e guide
            </h2>
          </div>
          <Link to="/blog" data-testid="home-blog-link" className="inline-flex items-center gap-2 text-[#5B9DFF] hover:text-white transition-colors text-sm font-medium">
            Vai al blog <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>

        <Carousel opts={{ align: "start", loop: articles.length > 3 }} className="w-full">
          <CarouselContent className="-ml-4">
            {articles.map((a) => (
              <CarouselItem key={a.id} className="pl-4 basis-full sm:basis-1/2 lg:basis-1/3">
                <Link
                  to={`/blog/${a.slug}`}
                  data-testid={`carousel-article-${a.slug}`}
                  className="group block relative overflow-hidden rounded-sm aspect-[4/3] border border-white/10"
                >
                  {a.featured_image ? (
                    <img src={mediaUrl(a.featured_image)} alt={a.featured_image_alt || a.h1} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  ) : (
                    <div className="h-full w-full bg-[#11182B]" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B1220] via-[#0B1220]/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    {a.category && <span className="text-[10px] uppercase tracking-[0.18em] text-[#5B9DFF] font-semibold">{a.category}</span>}
                    <h3 className="font-heading text-xl text-white leading-snug mt-1 line-clamp-2">{a.h1}</h3>
                  </div>
                </Link>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden sm:flex -left-4 bg-white/10 border-white/20 text-white hover:bg-white hover:text-[#0B1220]" />
          <CarouselNext className="hidden sm:flex -right-4 bg-white/10 border-white/20 text-white hover:bg-white hover:text-[#0B1220]" />
        </Carousel>
      </div>
    </section>
  );
}
